export const USER_EMAIL_STORAGE_KEY = 'simplifa_user_email';
export const USER_TEMP_PASSWORD = 'confirmation_code';
export const FORGOTTEN_PASSWORD_EMAIL_STORAGE_KEY = 'simplifa_forgotten_password_email';
